import { defineMessages } from 'react-intl';

type MessageKeys = 'noScenarios' | 'noSubagents';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noScenarios: {
			id: 'rovo-chat.view-agent.no-scenarios',
			defaultMessage: 'No scenarios',
			description: 'Text to display when there are no scenarios for the agent',
		},
		noSubagents: {
			id: 'rovo-chat.view-agent.no-subagents',
			defaultMessage: 'No subagents',
			description: 'Text to display when there are no subagents for the agent',
		},
	});

export default message;
